import { Link } from "react-router-dom";
import { CALENDAR_URL } from "@/lib/site";

const baseGold = "inline-flex items-center justify-center gap-2 font-display font-bold text-sm sm:text-base tracking-wide bg-gold text-ink-900 px-8 py-4 rounded-[2px] transition-all duration-300 shadow-[0_0_30px_rgba(201,146,58,0.25)] hover:bg-gold-light hover:shadow-[0_0_46px_rgba(201,146,58,0.45)]";
const baseGhost = "inline-flex items-center justify-center gap-2 font-display font-bold text-sm sm:text-base tracking-wide bg-transparent text-gold border border-gold px-8 py-4 rounded-[2px] transition-all duration-300 hover:bg-gold hover:text-ink-900";

export const GoldButton = ({ to, href, children, className = "", testid, ...props }) => {
  const cls = `${baseGold} ${className}`;
  if (href) return <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testid} className={cls} {...props}>{children}</a>;
  if (to) return <Link to={to} data-testid={testid} className={cls} {...props}>{children}</Link>;
  return <button data-testid={testid} className={cls} {...props}>{children}</button>;
};

export const GhostButton = ({ to, href, children, className = "", testid, ...props }) => {
  const cls = `${baseGhost} ${className}`;
  if (href) return <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testid} className={cls} {...props}>{children}</a>;
  if (to) return <Link to={to} data-testid={testid} className={cls} {...props}>{children}</Link>;
  return <button data-testid={testid} className={cls} {...props}>{children}</button>;
};

export const ApplyButton = ({ children = "Apply to Work With Us", testid = "apply-cta", className = "" }) => (
  <GoldButton href={CALENDAR_URL} testid={testid} className={className}>
    {children} <span aria-hidden>→</span>
  </GoldButton>
);
